import { apiService } from './api';
import { Category } from '../types/category';
import { AxiosResponse } from 'axios';

const CATEGORY_BASE_PATH = '/Category';

export const categoryService = {
    getAllCategories(): Promise<AxiosResponse<Category[]>> {
        return apiService.get<Category[]>(CATEGORY_BASE_PATH);
    },
};
